
<div class="container-fluid student-annotation disable-text-selection px-0 mx-0 " *ngIf="showPage">
    <div class="col-12">
        <div *ngIf="showAnnotation && annotationType != 'preview'" class="row clearBoth">
            <div *ngIf="!toolAdjust" class="col-12 p-1 tools-main-div bg-white mb-2" #toolbar>
                <div class="pdf-assign-btn pdf-tools col-12 d-inline-flex align-items-center justify-content-between">

                    <ng-select [(ngModel)]="textFontSize"
                               [items]="fontList"
                               bindLabel="value"
                               bindValue="value"
                               placeholder="--Font Size--"
                               class="col-3 pl-2"
                    >
                    </ng-select>
                    <img (click)="deleteSvg()" [ngClass]="selectedDeleteIcon ? 'selected-tool-color': ''"  alt="" src="assets/images/pdf-icons/Icon material-delete-1.png" style="cursor: pointer"  title="Delete">
                    <img (click)="incrementZoom(-0.1)" alt=""  src="assets/images/pdf-icons/minus-circle.png" style="cursor: pointer" title="Zoom-out">
                    <img (click)="incrementZoom(0.1)" alt="" src="assets/images/pdf-icons/add-circle.png" style="cursor: pointer" title="Zoom-in">
                    <img (click)="tools('rect', 'crosshair')"  [ngClass]="shapesType == 'rect'? 'selected-tool-color': ''" alt="" src="assets/images/pdf-icons/stop.png" title="Extract">
                    <img  (click)="tools('eraser', 'auto')" [ngClass]="shapesType == 'eraser'? 'selected-tool-color': ''" alt="" src="assets/images/pdf-icons/eraser@2x.png" title="Erase">
                    <img (click)=" tools('text', 'auto')"  [ngClass]="shapesType == 'text'? 'selected-tool-color': ''" alt="" src="assets/images/pdf-icons/Text.png" title="Text">
                    <img (click)=" tools('math', 'auto')"  [ngClass]="shapesType == 'math'? 'selected-tool-color': ''" alt="" src="assets/images/pdf-icons/math2.png" title="Math">
                    <img (click)=" tools('highlight', 'auto')"  [ngClass]="shapesType == 'highlight'? 'selected-tool-color': ''" alt="" src="assets/images/pdf-icons/highlighter-icon.png" title="Highlighter">
                    <img (click)="tools('path', 'auto')" [ngClass]="shapesType == 'path'? 'selected-tool-color': ''"  alt="" src="assets/images/pdf-icons/Icon awesome-pencil-alt.png" title="Sketch">
                    <span class="mr-2" (colorPickerChange)="svgColor = color" [(colorPicker)]="color" [style.background]="color" style="width: 39px;border: solid 2px;height: 19px;" title="Color"></span>
                    <img (click)="expandPage(true)" *ngIf="expandPdf && !expand" alt="" class="cursor p-0" src="assets/images/pdf-icons/arrowRight.png"  title="Hide Questions">
                    <img (click)="expandPage(false)" *ngIf="expandPdf && expand" alt="" class="cursor p-0" src="assets/images/pdf-icons/arrowLeft.png"  title="Show Questions">
                </div>

        </div>
            <div #toolbar *ngIf="toolHide == true && toolAdjust == true" class="col-12 p-3 d-flex justify-content-center stickyTool">
                <div class="col-md-9 d-flex justify-content-between align-items-center">
                    <div class="col-md-3 px-0">
                        <button (click)="eraseAlert()" class="btn btn-success pull-left">Clear all</button>
                    </div>
                    <div class="pdf-assign-btn d-flex justify-content-end pdf-tools col-md-7 pr-2 px-0 align-items-center">
                        <!--            <img (click)="backToQuestion()" (click)=" tools('math', 'auto')" [ngClass]="shapesType == 'math'? 'selected-tool-color': ''" alt=""  class="pull-right" src="assets/images/pdf-icons/math2.png" title="Math">-->
                        <img (click)="tools('rect', 'crosshair');backToQuestion()" [ngClass]="shapesType == 'rect'? 'selected-tool-color': ''" alt="" src="assets/images/pdf-icons/stop.png" title="Extract">
                        <img (click)="tools('eraser', 'auto');backToQuestion()" [ngClass]="shapesType == 'eraser'? 'selected-tool-color': ''" alt=""  src="assets/images/pdf-icons/eraser@2x.png" title="Eraser">
                        <img (click)="tools('text', 'auto');backToQuestion()" [ngClass]="shapesType == 'text'? 'selected-tool-color': ''" alt=""  src="assets/images/pdf-icons/Text.png" title="Text">
                        <img (click)="tools('path', 'crosshair');backToQuestion()" [ngClass]="shapesType == 'path'? 'selected-tool-color': ''" alt=""  src="assets/images/pdf-icons/Icon awesome-pencil-alt.png" title="Sketch">
<!--                        <span (click)="backToQuestion()" [(ngModel)]="svgColor" class="mr-2" (colorPickerChange)="svgColor = color" [(colorPicker)]="color" [style.background]="color" style="width: 39px;border: solid 2px;height: 19px;" title="Color"></span>-->
                        <input (click)="backToQuestion()" [(ngModel)]="svgColor" class="mr-3" name="favcolor" title="Color" type="color">
                    </div>
                </div>
            </div>
        <div class="col-12">
            <div *ngIf="!toolAdjust" [ngClass]="selectedDeleteIcon ? 'col-8': 'col-12'" id="pdf-page" class="pdf-mainpage scrollPanel-student"
                 style="margin-right: -24px !important; padding-left: 14px !important;"  #pdfPage>
                <div *ngIf="customPdfLoader" id="custom-pdf-loader" style="height: 100vh;">
                    <img alt="" src="assets/images/pre-loader/loader-01.svg">
                </div>
                <pdf-viewer
                        id="pdf-view" [src]="pdfTemplate" [zoom]="zoom"
                        (page-rendered)="pageRendered($event)"
                        (pageChange)="pagechanging($event)"
                        (pages-initialized)="pagechanging($event)"
                        [(page)]="pageVariable"
                        [fit-to-page]="true"
                        [original-size]="true"
                        (after-load-complete)="callBackFn($event)"
                        [render-text]="false"  [show-all]="true"
                        style="display: block;height: 100vh;"></pdf-viewer>
            </div>
            <div #pdfPage (click)="mouseEvent1($event)" (dblclick)="editText($event)"
                 *ngIf="toolHide && toolAdjust"
                 (scrolled)="scrollDownPads($event)"
                 [fromRoot]="true"
                 [infiniteScrollContainer]="'.scrollWritingPad'"
                 [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                 [scrollWindow]="false"
                 class="scrollWritingPad col-md-12 px-0"
                 infiniteScroll
                 [id]="'workArea'" [ngStyle]="{'overflow' : allowWorkSpaceScroll ? 'scroll' : 'hidden'}" >
                <div *ngIf="customPdfLoader" id="custom-pdf-loader" style="height: 100vh;">
                    <img alt="" src="assets/images/pre-loader/loader-01.svg">
                </div>
                <pdf-viewer (page-rendered)="pageRendered($event)"
                            (after-load-complete)="callBackFn($event)"
                            (pageChange)="pagechanging($event)"
                            (pages-initialized)="pagechanging($event)"
                            [(page)]="pageVariable"
                            [fit-to-page]="true"
                            [original-size]="true"
                            [render-text]="shapesType == 'select'"
                            [show-all]="true"
                            [src]="pdfTemplate"
                            [zoom]="zoom"
                            style="display: block; background-color: #f8f8f9"></pdf-viewer>
            </div>

            <div class="col-4 w-50" *ngIf="selectedDeleteIcon">
                <div class="row mt-5">
                    <div class="w-100">
                        <button type="button" *ngIf="deleteAnnatation" (click)="backToQuestion()" class="btn btn-primary w-100 mb-3">Back</button>
                    </div>
                    <ng-container *ngIf="deleteAnnatation">
                        <app-remove-student-annotation [items]="itemSelect"
                                                       (undoDeleteAnnatation)="undoDeleteAnnatation($event)"
                                                       (hoverremoveItem)="hoverRemoveItemEnter($event)"
                                                       (hoverleaveremoveItem)="hoverLeaveRemoveItemEnter($event)"
                                                       (removeItem)="removeAnnatation($event)"
                                                       (openDeleteDialog)="deleteAction()"
                                                       class="scrollPanel"></app-remove-student-annotation>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>

<ng-template  #class let-c="close" let-d="dismiss" >
    <div class="modal-body" style="border: 0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 text-right">
                    <i (click)="close()" class="fa fa-close cursor" style="font-size: 1rem"></i>
                </div>
                <div class="col-12 text-center">
                    <h3 class="modal-title headerText">Delete All Annotation</h3>
                </div>

                <div class="col-12">
                    <h5 class="text-center mt-3">Are you sure  want to delete All Annotations ?</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="deleteAllAnnotation()" class="btn btn-outline-primary" type="button">Yes</button>
    </div>
</ng-template>

<ng-template #eraser let-c="close" let-d="dismiss">
    <div class="modal-body" style="border: 0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <h5 class="text-center mt-3">Please double click on annotation to erase</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="close()" class="btn btn-outline-primary" type="button">Got it</button>
    </div>
</ng-template>
<ng-template #delete let-c="close" let-d="dismiss">
    <div class="modal-body" style="border: 0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <h5 class="text-center mt-3">Coming Soon</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="close()" class="btn btn-outline-primary" type="button">Got it</button>
    </div>
</ng-template>
<ng-template #mathShow let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4>Enter values</h4>
    </div>
    <div class="modal-body" style="border: 0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <app-tiny-mice (emitEditorValue)="mathValue($event)"
                                   [editorPatchValue]= "editMathValue == '' ? false : editMathValue.rect.text"
                                   [height]="130"
                                   [id]="'multiQues'"
                                   [imageToolHide]="true"
                                   [showDropBtn]="false"
                                   [showInputBtn]="false">
                    </app-tiny-mice>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="mathAnnotation()" class="btn btn-outline-primary" type="button">{{editMathValue == '' ? 'Done' : 'Update'}}</button>
    </div>
</ng-template>

<ng-template #eraseAll let-c="close" let-d="dismiss">
    <div class="modal-header d-flex justify-content-between">
        <h4>Erase Annotation</h4>
        <i (click)="close()" class="fa fa-times-circle cursor" style="font-size: 1.2rem"></i>
    </div>
    <div class="modal-body" style="border: 0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 py-3">
                    <label class="mb-0">Are you sure? Do you want to erase all writing for this question</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="close()" class="btn btn-outline-primary" type="button">Close</button>
        <button (click)="clearAll(); allowWorkSpaceScroll = true;" class="btn btn-primary" type="button">Confirm</button>
    </div>
</ng-template>
